module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/nba/weekly/default-e148b16863538af88ff4970da7981ee8.svg";